import Vue from "vue";
import "./style.scss";
const instances = new Map();
let count = 0;
export default class CsDialog {
  id = count++; // 弹框的唯一ID
  dialog = null; // 弹框组件的实例
  state = Vue.observable({ visible: true }); // 弹框显示隐藏，应为使用了el-dialog,所以这里需要一个双休绑定的数据
  lisenter = {}; // 内容组件监听的事件
  content = null; // 内容组件
  options = {}; // 内容组件的参数
  router = null; // 路由
  constructor(title, width, customClass) {
    this.title = title;
    this.width = width;
    this.customClass = customClass;
  }

  open = () => {
    const that = this;
    const DialogComponent = that.content;
    const com = {
      render() {
        return (
          <el-dialog
            title={that.title}
            visible={that.state.visible}
            before-close={that.close}
            custom-class={that.customClass}
            onClosed={that.closed}
            width={that.width}
            close-on-click-modal={false}
          >
            {that.footerEl && (
              <template slot="footer">
                <span id="cs-dialog-footer-placeholder"></span>
              </template>
            )}
            <DialogComponent
              attrs={{ ...that.options }}
              on={{ ...that.lisenter }}
              onClose={that.close}
            ></DialogComponent>
          </el-dialog>
        );
      },
      mounted() {
        this.$nextTick(() => {
          const footerNode = this.$el.querySelector(that.footerEl);
          if (footerNode) {
            footerNode.style.display = "none";
            const elFooterNode = this.$el.querySelector(
              "#cs-dialog-footer-placeholder"
            ).parentNode;
            if (elFooterNode) {
              elFooterNode.removeChild(elFooterNode.firstChild);
            }
            elFooterNode.append(...footerNode.childNodes);
          }
        });
      },
    };
    if (that.router !== null) {
      com.router = that.router;
    }
    const Instance = Vue.extend(com);
    that.dialog = new Instance().$mount();
    document.body.appendChild(that.dialog.$el);

    instances.set(this.id, that);
    return that;
  };

  /**
   * 弹窗的关闭事件,所有关闭弹框的方式都会调用这个方法
   */
  close = () => {
    this.state.visible = false;
  };

  /**
   * Dialog 关闭动画结束时的回调
   */
  closed = () => {
    instances.delete(this.id);
    // 如果有监听close事件的话,就调用
    if (this.lisenter.close) {
      this.lisenter.close();
    }
    this.dialog.$destroy();
    this.dialog.$el.parentNode.removeChild(this.dialog.$el);
  };

  center = () => {
    this.customClass = [this.customClass, "cs-dialog-center-layout"]
      .filter(Boolean)
      .join(" ");
    return this;
  };

  footer = (footerEl = ".cs-dialog-footer") => {
    this.footerEl = footerEl;
    return this;
  };

  component = (content) => {
    this.content = content;
    return this;
  };

  props = (options) => {
    this.options = options;
    return this;
  };

  on = (type, callback) => {
    this.lisenter[type] = callback;
    return this;
  };

  route = (root) => {
    this.router = root.$router;
    return this;
  };

  static closeAll = () => {
    for (const [, item] of instances) {
      item.close();
    }
  };
}
